import { CompareOutlined } from '@mui/icons-material';
import { Button } from '@renderer-ui-library/atoms';
import { MachineType } from '@internal/utils/machine/MachineType';
import { localeNamespace } from '@internal/utils/machine/i18n/Locale';
import { translations } from 'i18n/translations';
import { useTranslation } from 'next-i18next';
import React, { useCallback, useContext } from 'react';
import { tracker } from 'utils/tracking/tracker';
import { MachineComparisonContext } from '../CompareMachines/MachineComparisonContext';
import styles from './compareMachinesButton.module.scss';

type Props = {
    enabled: boolean;
    machineType: MachineType | undefined;
};

export const CompareMachinesButton: React.FC<Props> = React.memo(props => {
    const { t } = useTranslation(localeNamespace.common);

    const { toggleCompareMode, isCompareModeEnabled } = useContext(
        MachineComparisonContext,
    );

    const handleCompareModeClick = useCallback(() => {
        if (!props.machineType) {
            return;
        }

        if (!isCompareModeEnabled) {
            tracker.trackEvent({
                name: 'click',
                target_name: 'button.serp.compare_machines',
                is_interaction: true,
            });
        }

        toggleCompareMode(props.machineType);
    }, [isCompareModeEnabled, props.machineType, toggleCompareMode]);

    return (
        <Button
            variant="text"
            onClick={handleCompareModeClick}
            className={styles.compareButton}
            disabled={!props.enabled}
        >
            <CompareOutlined fontSize="small" />
            {t(translations.compareMachinesSearchResultButtonText)}
        </Button>
    );
});

CompareMachinesButton.displayName = 'CompareMachinesButton';
